import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRegistries = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.25 2H13.65C13.4291 2 13.25 2.17909 13.25 2.4V10.35C13.25 10.5709 13.4291 10.75 13.65 10.75H21.6C21.8209 10.75 22 10.5709 22 10.35V4.75C22 3.23122 20.7688 2 19.25 2ZM14.75 9.25V3.5H19.25C19.9404 3.5 20.5 4.05964 20.5 4.75V9.25H14.75Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 4.75C4.20507 4.75 2.75 6.20507 2.75 8V18C2.75 19.7949 4.20507 21.25 6 21.25H16C17.7949 21.25 19.25 19.7949 19.25 18V12.25H11.75V5.15C11.75 4.92909 11.5709 4.75 11.35 4.75H6ZM10.25 12.25H4.25V8C4.25 7.0335 5.0335 6.25 6 6.25H10.25V12.25ZM4.25 18V13.75H10.25V19.75H6C5.0335 19.75 4.25 18.9665 4.25 18ZM16 19.75H11.75V13.75H17.75V18C17.75 18.9665 16.9665 19.75 16 19.75Z",
		fill: "currentColor"
	})]
});
export { SvgIconRegistries as ReactComponent };
